import Unknown from '@clearkit/icons/glyphs/Unknown';
import classnames from 'classnames';
import { CKTooltip } from 'clearkit';

const FieldMappingHeaders = ({ hasEnrichmentBetaUIFlag = false }) => {
  const headerClasses = classnames('mb-3 text-gray-600 text-base font-medium', {
    'mt-6 mapping-row-header': !hasEnrichmentBetaUIFlag,
    'selective-enrichment-mapping-header': hasEnrichmentBetaUIFlag,
  });

  return (
    <div className={headerClasses}>
      <div>Source</div>
      <div className="pl-4">Target</div>
      <div className="flex items-center pl-8 gap-1">
        {hasEnrichmentBetaUIFlag
          ? 'Field overwrite preference'
          : 'Hard Overwrite'}
        <CKTooltip
          placement="top-end"
          tooltip="By default, Clearbit will never overwrite your manually entered
              data. Enabling Hard Overwrite will ensure that we force overwrite
              the field with new data regardless of its previous value."
        >
          <Unknown height="16" width="16" />
        </CKTooltip>
      </div>
    </div>
  );
};

export default FieldMappingHeaders;
